import styles from '../TopUpStatusAlertBox.module.css';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import { Button, Icon } from '@iwoca/orion';
import messages from './Alerts.messages';
import { FormattedMessage } from 'react-intl';

export const TopUpEligibleAlert = ({
    onApplyNowClick
}: {
    onApplyNowClick: () => void;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            iconName="userCheck"
            className={styles.blueAlertBox}
            iconClassName={styles.blueAlertBoxIcon}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            {...messages.topupEligibleAlertTitle}
                        />
                    </strong>
                    <FormattedMessage
                        {...messages.topupEligibleAlertSubtitle}
                    />
                </>
            }
            cta={
                <Button variant="tertiary" onClick={onApplyNowClick}>
                    <FormattedMessage {...messages.applyNowCTAText} />
                    <Icon icon="angleRight" />
                </Button>
            }
        />
    );
};
